import { render, staticRenderFns } from "./areaAcademyVideo.vue?vue&type=template&id=dd6538d6&scoped=true"
import script from "./areaAcademyVideo.vue?vue&type=script&lang=js"
export * from "./areaAcademyVideo.vue?vue&type=script&lang=js"
import style0 from "./areaAcademyVideo.vue?vue&type=style&index=0&id=dd6538d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6538d6",
  null
  
)

export default component.exports